<template>
  <!-- 计价子组件 -->
  <div class="title">
    <span>*</span>
    <i style="paddinng-bottom:0.6rem"> {{msg}}:</i>
    <div  style="padding-top:0.5rem"><img @mouseover.stop="show"  @mouseout.stop="shoew=false" src="../../assets/imges/问号图标1.png"
           alt="">
           </div>
             <div class="HiddenBox"
         v-show="shoew">
   <p style="margin-top:0.6rem;margin-bottom:0.5rem;font-weight: 550;">{{text}}</p>
   <hr>
   <p style="text-indent:2em;line-height: 1.5rem;font-size:0.8rem;letter-spacing: 2px;margin-top:0.6rem;margin-bottom:0.5rem">{{TextInterpretation}}</p>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      shoew:false,//影藏显示
      text:'',//显示头部
      TextInterpretation:""//提示主体
    }
  },
  methods:{
    //   鼠标经过
      show(){
         if(this.explain.text1==""||this.explain.text2==""){
           this.shoew=false;
         }else{
                this.shoew=true,
         this.text=this.explain.text1
         this.TextInterpretation=this.explain.text2
         }
        
      }
  },
  props: {
    msg: String,
    explain:Object
  }
  
}
</script>
<style lang="scss" scoped>
.HiddenBox {
    
  border: 0.1rem solid #ddd;
  border-radius:0.5rem ;
  width: 30rem;
  position: absolute;
  right: -300%;
  background-color: #ffffff;
  z-index: 5;
  padding: 0.5rem;
  box-shadow: #83cbac 0 0 5px ;
}
.title {
  position: relative;
  background-color: #ffffff;
  span {
    font-size: 1.5rem;
    color: #f00;
    position: absolute;
    bottom: -1.1rem;
  }
  i {
    position: absolute;
    bottom: -0.4rem;
    left: 2.5rem;
    font-style: unset;
    font-weight: 600;
    margin-right: 0.5rem;
    display: inline-block;
    width: 110px;
    text-align-last: justify;
    text-align: justify;
    font-size: 0.8rem;
    font-weight: 700;
  }
  div {
    display: inline-block;
    img {
      position: absolute;
      bottom: -0.2rem;
      right: 0.6rem;
      width: 1rem;
      margin-top: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrivateComponent/title.vue